import Cookies from 'js-cookie'
import { getSystemParam, getIsMulHospital } from '@/frameworks/api/login'
import { convertToNavmenu } from '@/common/utils/navMenu'
// import { getNotifyNotReadCount } from '../../api/notify'
// import { getBcsAdminUiconfigs } from '../../api/backendConfig'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    notifyCount: 0, // 未读消息数量
    device: 'desktop',
    language: Cookies.get('language') || 'en',
    size: Cookies.get('size') || 'medium',
    nav_style: 'nonTopMenu', // nonTopNav:没有顶部栏；nonTopMenu：有顶部栏，但没有顶部菜单；withLeftMenu：顶部菜单和左侧菜单；空：只显示顶部菜单；nonNav：不显示任何导航菜单
    hasLeftMenu: true,
    selected_firstL_level_menuitem: null,
    nav_menus: [], // 用户菜单集合，树型层次结构
    isContentFillBody: false,
    hasSubMenusOfTopMenu: false, // 是否当前顶级选中菜单拥有子菜单,
    isInsideFrame: false,
    moduleUiConfigs: {},
    systemParam: {},
    isMulHospital: false,
    flag: true //防止出現多次返回登陸頁彈框
  },
  mutations: {
    SET_NOTIFY_COUNT: (state, notifyCount) => {
      state.notifyCount = notifyCount
    },
    SUB_NOTIFY_COUNT: (state) => {
      if (state.notifyCount > 0) {
        state.notifyCount = state.notifyCount - 1
      }
    },
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    SET_NAV_STYLE: (state, nav_style) => {
      state.nav_style = nav_style
    },
    SET_HAS_LEFT_MENU: (state, hasLeftMenu) => {
      state.hasLeftMenu = hasLeftMenu
    },
    SET_NAVMENUS: (state, menus) => {
      state.nav_menus = menus
    },
    SET_SELECT_FIRSTL_LEVEL_MENUITEM: (state, menuItem) => {
      state.selected_firstL_level_menuitem = menuItem
    },
    SET_CONTENT_FILL_BODY: (state, isFill) => {
      state.isContentFillBody = isFill
    },
    SET_HAS_SUBMENUS_OF_TOPMENU: (state, hasMenu) => {
      state.hasSubMenusOfTopMenu = hasMenu
    },
    SET_IS_INSIDE_FRAME: (state, isInsideFrame) => {
      state.isInsideFrame = isInsideFrame
    },
    SET_MODULE_UI_CONFIGS: (state, configs) => {
      state.moduleUiConfigs = configs
    },
    SET_FLAG: (state, flag) => {
      state.flag = flag
    },
    SET_SYSTEM_PARAM: (state, systemParam) => {
      state.systemParam = systemParam
    },
    SET_IS_MUL_HOSPITAL: (state, isMulHospital) => {
      state.isMulHospital = isMulHospital
    }
  },
  actions: {
    queryNotifyNotReadCount({ commit }, params) {
      getNotifyNotReadCount(params).then((response) => {
        commit('SET_NOTIFY_COUNT', parseInt(response.total))
      })
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
    setNavStyle({ commit }, navStyle) {
      commit('SET_NAV_STYLE', navStyle)
    },
    initIsInsideFrame({ commit, state }, isInsideFrame) {
      commit('SET_IS_INSIDE_FRAME', isInsideFrame)
      if (state.isInsideFrame) {
        commit('SET_NAV_STYLE', 'nonTopNav')
      }
    },
    // loadUserNavMenus({ commit, rootGetters }, UserId) {
    //   const menuDtosFromServer = rootGetters.loginUserInfo.navMenus;

    //   const menus = menuDtosFromServer.map(item => convertToNavmenu(item, ""));
    //   // const menus = getMenuData();
    //   commit("SET_NAVMENUS", menus);
    // },
    initNavmenus({ commit, state, rootGetters, dispatch }, menuDtosFromServer) {
      // const menuDtosFromServer = rootGetters.loginUserInfo.navMenus;
      const menus = menuDtosFromServer.map((item) => convertToNavmenu(item, ''))
      // const menus = getMenuData();
      commit('SET_NAVMENUS', menus)
      if (state.nav_style === 'nonTopNav' || state.nav_style === 'nonTopMenu') {
        const virtualTopMenuObj = {
          id: '*',
          children: menus
        }
        // commit("SET_SELECT_FIRSTL_LEVEL_MENUITEM", virtualTopMenuObj);
        dispatch('changeSelectfirstLevelMenuItem', virtualTopMenuObj)
      }
      return Promise.resolve(menus)
    },
    changeSelectfirstLevelMenuItem({ commit }, menuItem) {
      commit('SET_SELECT_FIRSTL_LEVEL_MENUITEM', menuItem)
      if (menuItem && menuItem.children && menuItem.children.length) {
        // commit("SET_NAV_STYLE", "withLeftMenu");
        commit('SET_HAS_LEFT_MENU', true)
      } else {
        // commit("SET_NAV_STYLE", "");
        commit('SET_HAS_LEFT_MENU', false)
      }
    },

    // 组件的内容需要铺满除标题栏外的区域
    setContentFillBody({ commit }, isFill) {
      commit('SET_CONTENT_FILL_BODY', isFill)
    },
    loadModuleUiConfigs({ commit }) {
      // return getBcsAdminUiconfigs().then((data) => {
      //   commit('SET_MODULE_UI_CONFIGS', data)
      // })
    },
    setFlag({ commit }, flag) {
      commit('SET_FLAG', flag)
    },
    getIsMulHospital({ commit }, isMulHospital) {
      return new Promise((resolve, reject) => {
        getIsMulHospital({})
          .then((res) => {
            if (res.success) {
              commit('SET_IS_MUL_HOSPITAL', res.data.IsMulHospital == '1')
              resolve()
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    getSystemParam({ commit, state, dispatch }, params) {
      return new Promise((resolve, reject) => {
        getSystemParam(params)
          .then((res) => {
            /**
             * data:
             * UserName 用户id
             * userDisplayName 用户显示名
             * loginUserToken 登录后的token信息
             * navMenus 用户可访问菜单
             */
            if (res.success) {
              const xtmjList = res.data || []
              const wdTypeMj = xtmjList.find((item) => item.MJDM == 1193)

              let wdType = wdTypeMj.JLZT || '2'
              if (wdType == '0') wdType = '2'

              wdType += '0'
              commit('SET_SYSTEM_PARAM', {
                xtmjList,
                wdType
              })
              resolve()
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default app
